import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Divider,
    Link as MuiLink,
    IconButton,
    Stack,
} from "@mui/material";
import newletter from '../assets/newsletter.png'
import useResponsive from "../hooks/useResponsive";
import { useNavigate } from "react-router-dom";
import { fetchCategories } from "../services/Apis"; // <-- Import your API

// Font Awesome CDN should be included in your index.html for these to work:
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css" />

const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Blog", path: "/blog" },
    { label: "FAQ's", path: "/faq" },
    { label: "Contact Us", path: "/contact" },
    { label: "Privacy Policy", path: "/privacy-policy" },
];

const socialIcons = [
    { icon: "fab fa-facebook-f", label: "Facebook", href: "#" },
    { icon: "fab fa-twitter", label: "Twitter", href: "#" },
    { icon: "fab fa-linkedin-in", label: "LinkedIn", href: "#" },
    { icon: "fab fa-instagram", label: "Instagram", href: "#" },
    { icon: "fab fa-youtube", label: "YouTube", href: "#" },
    { icon: "fab fa-snapchat", label: "Snapchat", href: "#" },
];

const Footer = ({ news }) => {
    const { isSmallScreen } = useResponsive();
    const navigate = useNavigate();

    // Add state for categories
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const getCategories = async () => {
            const data = await fetchCategories();
            setCategories(data);
        };
        getCategories();
    }, []);

    return (


        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'end' }}>
            {/* Orange Card - Newsletter */}
            {news && (
                <Box
                    sx={{
                        width: { xs: "95%", sm: "80%", md: "65%", lg: "60%" }, // 70% on desktop, 95% on mobile
                        borderRadius: 3,
                        background: "#fff",
                        p: 0,
                        mx: "auto",
                        mb: { xs: -8, md: -10 }, // Negative margin to overlap footer
                        zIndex: 2,
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "primary.main",
                            borderRadius: 2,
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexDirection: isSmallScreen ? "column" : "row",
                            px: isSmallScreen ? 0 : 3,
                            py: isSmallScreen ? 0 : 3,
                            width: "100%", // Always fill parent
                            boxShadow: "0 0 0 10px #fff",
                            gap: isSmallScreen ? 2 : 0,
                            maxHeight: isSmallScreen ? "auto" : 130,
                            mx: "auto",
                            position: "relative",
                        }}
                    >


                        <Box flex={1} sx={{ zIndex: 1, maxWidth: isSmallScreen ? '80%' : '60%' }}>
                            <Typography
                                variant="h3"
                                sx={{
                                    color: "#fff",
                                    mb: 1,
                                    pt: isSmallScreen ? 3 : 0,

                                }}
                            >
                                Subscribe for Newsletter
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    color: "#fff",
                                    mb: 2,
                                    fontWeight: 400,


                                }}
                            >
                                Get more updates and offers through email.
                            </Typography>
                            <Box
                                component="form"
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    maxWidth: 600,

                                    borderRadius: 1,
                                    boxShadow: "none",
                                    width: "100%",
                                    gap: { xs: 1.5, sm: 0 }, // spacing between input and button on small screens
                                }}
                                onSubmit={(e) => e.preventDefault()}
                            >
                                <TextField
                                    variant="outlined"
                                    placeholder="Enter your email id"
                                    size="small"
                                    fullWidth
                                    sx={{
                                        bgcolor: "#fff",
                                        flex: 1,

                                        borderTopLeftRadius: {
                                            xs: 2,
                                            sm: 8, // ✅ only on sm and up
                                        },
                                        borderBottomLeftRadius: {
                                            xs: 2,
                                            sm: 8, // ✅ only on sm and up
                                        },
                                        borderTopRightRadius: {
                                            xs: 2,
                                            sm: 0,
                                        },
                                        borderBottomRightRadius: {
                                            xs: 2,
                                            sm: 0,
                                        },
                                        "& fieldset": {
                                            border: "none",
                                        },
                                        "&:hover fieldset": {
                                            border: "none",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "none",
                                        },
                                        input: {
                                            color: "#222",
                                            py: 1.5,
                                            fontWeight: 400,
                                            px: 2,
                                            fontSize: 14,
                                            width: "100%",
                                            fontFamily: "Poppins, sans-serif",
                                        },

                                    }}
                                />


                                <Button disableFocusRipple disableRipple
                                    variant="contained"
                                    type="submit"
                                    sx={{
                                        mt: { xs: 1, sm: 0 }, // margin-top on small screens to push button below input
                                        width: { xs: "100%", sm: 150 },
                                        bgcolor: "#FFC107",
                                        color: "#222",
                                        fontWeight: 400,
                                        px: 4,
                                        borderRadius: { xs: 2, sm: "0 8px 8px 0" },
                                        boxShadow: "none",
                                        fontSize: 18,
                                        fontFamily: "Poppins, sans-serif",
                                    }}
                                >
                                    Subscribe
                                </Button>
                            </Box>

                        </Box>
                        <Box
                            sx={{
                                ml: isSmallScreen ? 0 : 6,
                                mt: isSmallScreen ? 3 : 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: isSmallScreen ? "static" : "absolute",
                                right: isSmallScreen ? "auto" : 40,
                                bottom: isSmallScreen ? "0" : 0,
                                zIndex: 1,
                            }}
                        >

                            <Box
                                component="img"
                                loading="lazy"
                                src={newletter}
                                alt="Newsletter" sx={{
                                    height: 140, objectFit: "cover",
                                }}
                            />
                        </Box>
                    </Box>
                </Box>


            )}
            {/* Footer */}
            <Box
                sx={{
                    bgcolor: "#393939",
                    color: "#fff",
                    pt: news ? { xs: 12, md: 15 } : 6, // Padding top to make space for overlap
                    // ...rest of your footer styles...
                }}
            >


                <Box
                    sx={{
                        maxWidth: 1300,
                        mx: "auto",
                        px: 2
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            flexDirection: { xs: "column", md: "row" },
                            justifyContent: { xs: "flex-start", md: "space-between" },
                            alignItems: { xs: "flex-start", md: "flex-start" },
                            gap: { xs: 0, md: 0 },
                            pb: isSmallScreen ? 0 : 4,

                            textAlign: "left", // <-- Always left
                        }}
                    >
                        <Box sx={{ flex:0   , minWidth: 160, mb: { xs: 3, md: 0 } }}>
                            <Typography variant="h6" mb={1.5} sx={{ wordBreak: "break-word", mx: 0, fontSize: '16px', width: "fit-content" }}>
                                Quick Links
                            </Typography>
                            {quickLinks.map(link => (
                                <Typography
                                    key={link.label}
                                    variant="h6"
                                    sx={{
                                        mb: 0.5,
                                        fontWeight: 400,
                                        fontSize: '13px',
                                        color: '#C3C3C3',
                                        cursor: "pointer",
                                        "&:hover": { color: "#FFC107" }
                                    }}
                                    onClick={() => navigate(link.path)}
                                >
                                    – {link.label}
                                </Typography>
                            ))}
                        </Box>

                        <Box sx={{ minWidth: 350, flex: 0 ,  mb: { xs: 3, md: 0 } }}>
                            <Typography 
                                variant="h6" 
                                mb={1.5} 
                                sx={{ 
                                    wordBreak: "break-word", 
                                    textAlign: 'center',
                                    fontSize: '16px',
                                    width: '100%',
                                    mb: 2
                                }}
                            >
                                Popular Categories
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 4 }}>
                                <Box sx={{ flex: 1 }}>
                                    {categories.slice(0, Math.ceil(categories.length / 2)).map(cat => (
                                        <Typography
                                            key={cat?.subCategories?.id}
                                            variant="h6"
                                            sx={{
                                                mb: 0.5,
                                                fontWeight: 400,
                                                fontSize: '13px',
                                                color: '#C3C3C3',
                                                cursor: "pointer",
                                                "&:hover": { color: "#FFC107" }
                                            }}
                                            onClick={() => navigate(`/filtered-books?subcat=${cat?.subCategories[0]?.id} &cat=${cat?.id}`)}
                                        >
                                            – {cat.name}
                                        </Typography>
                                    ))}
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    {categories.slice(Math.ceil(categories.length / 2)).map(cat => (
                                        <Typography
                                            key={cat?.subCategories?.id}
                                            variant="h6"
                                            sx={{
                                                mb: 0.5,
                                                fontWeight: 400,
                                                fontSize: '13px',
                                                color: '#C3C3C3',
                                                cursor: "pointer",
                                                "&:hover": { color: "#FFC107" }
                                            }}
                                            onClick={() => navigate(`/filtered-books?subcat=${cat?.subCategories[0]?.id} &cat=${cat?.id}`)}
                                        >
                                            – {cat.name}
                                        </Typography>

                                    ))}
                                    {console.log(categories)}
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ minWidth: { md: 450, xs: 300 }, flex: 0, mb: { xs: 3, md: 0 } }}>
                            <Typography variant="h6" mb={1.5} sx={{ wordBreak: "break-word", mx: 0, width: "fit-content", fontSize: '16px' }}>
                                Contact Us
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>
                                <i className="fas fa-map-marker-alt" style={{ marginRight: 8, fontSize: 12, marginTop: 3 }} />
                                <Typography variant="body2" sx={{ mb: 0.5, color: '#C3C3C3', fontWeight: 400, fontSize: '13px', fontFamily: "Poppins, sans-serif" }}>
                                    #102A Images Capital Park, Silicon Valley, Madhapur<br />
                                    Hyderabad – 500081
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                <i className="fas fa-envelope" style={{ marginRight: 8, fontSize: 12 }} />
                                <Typography variant="body2" sx={{ mb: 0.5, color: '#C3C3C3', fontWeight: 400, fontSize: '13px', fontFamily: "Poppins, sans-serif" }}>
                                    info@indianbookhouse.com
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                                <i className="fas fa-phone-alt" style={{ marginRight: 8, fontSize: 16 }} />
                                <Typography variant="body2" sx={{ fontSize: 15, color: '#C3C3C3', fontWeight: 400, fontFamily: "Poppins, sans-serif" }}>
                                    040-755576565
                                </Typography>
                            </Box>
                            <Typography variant="h6" mt={2} mb={1}>
                                Follow Us
                            </Typography>
                            <Stack direction="row" spacing={0.1} sx={{ mt: 1, flexWrap: "wrap" }}>
                                {socialIcons.map(({ icon, label, href }) => (
                                    <IconButton
                                        key={label}
                                        color="inherit"
                                        size="large"
                                        component="a"
                                        href={href}
                                        aria-label={label}
                                        sx={{
                                            fontSize: 22,
                                            color: "#fff",
                                            borderRadius: "50%",
                                            "&:hover": { color: "#D44F1C", bgcolor: "transparent" },
                                            transition: "all 0.2s",
                                            width: 44,
                                            height: 44,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 0,
                                            background: "none",
                                        }}
                                    >
                                        <i className={icon}></i>
                                    </IconButton>
                                ))}
                            </Stack>
                        </Box>
                    </Box>
                    <Divider
                        sx={{
                            bgcolor: "#555",
                            width: "98vw",
                            position: "relative",
                            left: "50%",
                            right: "50%",
                            transform: "translateX(-50%)",
                            my: 2,
                        }}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "space-between",
                            pb: 2,
                            fontSize: 14,
                        }}
                    >
                        <Box sx={{ mb: { xs: 1, md: 0 } }}>
                            <Typography variant="body2" sx={{ fontWeight: 400, fontFamily: "Poppins, sans-serif" }}>
                                © 2025 All rights reserved by Indian Book House.
                            </Typography>
                        </Box>
                        <Box sx={{ textAlign: "left", mb: { xs: 1, md: 0 } }}>
                            <MuiLink onClick={() => window.location.href = "/privacy-policy"} color="inherit" underline="hover" sx={{ mx: isSmallScreen ? 0 : 1, fontWeight: 400, fontSize: 12, fontFamily: "Poppins, sans-serif" , cursor: 'pointer' }}>
                                Privacy Policy
                            </MuiLink>
                            |
                            <MuiLink onClick={() => window.location.href = "/terms-and-conditions"} color="inherit" underline="hover" sx={{ fontWeight: 400, mx: isSmallScreen ? 0.5 : 1, fontSize: 12, fontFamily: "Poppins, sans-serif" , cursor: 'pointer' }}>
                                Terms and Conditions
                            </MuiLink>
                            |
                            <MuiLink onClick={() => window.location.href = "/exchange-policy"} color="inherit" underline="hover" sx={{ fontWeight: 400, mx: isSmallScreen ? 0.5 : 1, fontSize: 12, fontFamily: "Poppins, sans-serif" , cursor: 'pointer'}}>
                                Exchange Policy
                            </MuiLink>
                        </Box>
                        <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                            <Typography variant="body2" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: 400 }}>
                                Website designed and developed by Abilio IT Solutions
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>)
};

export default Footer;